let cache = {};


export default class ShortestPathGenerator
{

  constructor(game) {

    this.game = game;
    this.indexed = false;

  }

  index(){

    this.indexed = true;

    this.game.paths.forEach(path => {

      if (!path.a.paths) {
        path.a.paths = [];
      }
      path.a.paths.push(path);

      if (!path.b.paths) {
        path.b.paths = [];
      }
      path.b.paths.push(path);

      path.length = Math.sqrt(Math.pow( path.a.x - path.b.x, 2) + Math.pow( path.a.y - path.b.y, 2));

    });

  }

  garbageCollect() {

    cache = {};
    this.indexed = false;

  }

  getDirection(fromPoint, toPoint) {

    if (fromPoint.x === toPoint.x) {
      // moving vertically
      return 1;
    }

    // must be moving horizontally or standing still
    return 0;

  }

  simplify(path) {

    let points = [];

    let prevSectionDirection = null;

    // add first point on our path
    points.push({ x :path[0].x, y : path[0].y});

    for (let i = 1; i < path.length - 1; i++) {

      let direction = this.getDirection(path[i-1], path[i]);
      let nextDirection = this.getDirection(path[i], path[i+1]);

      if (direction !== nextDirection) {
        points.push({ x :path[i].x, y : path[i].y});
      }

    }

    // add last point on our path
    points.push({ x :path[path.length - 1].x, y : path[path.length - 1].y});

    let length = 0;


    for (let i = 1; i < points.length; i++) {

      length += Math.sqrt(Math.pow(points[i-1].x - points[i].x, 2) + Math.pow(points[i-1].y - points[i].y, 2));

    }

    return { length, points };

  }

  generate(startNode, endNode)
  {

    let cacheName = startNode.id + '-' + endNode.id;

    if (cache.hasOwnProperty(cacheName)) {
      return cache[cacheName];
    }

    let toVisit = [];
    let visited = [];
    let foundPath = null;

    let distances = {};

    toVisit.push({ node : startNode, path : [startNode], distance : 0 });

    let iterations = 200;

    while (toVisit.length > 0) {

      let current = toVisit.splice(0,1)[0];

      if (current.node === endNode) {
        foundPath = current.path;
        break;
      }

      // already visited
      if (visited.includes(current.node)) {
        continue;
      }

      visited.push(current.node);

      current.node.paths.forEach(path => {

        let node = path.a === current.node ? path.b : path.a;

        if (!visited.includes(node)) {

          toVisit.push({ node, path : current.path.concat([node]), distance : current.distance + path.length});

        }

      });

      toVisit.sort((a, b) => {

        if (a.distance === b.distance) return 0;
        if (a.distance < b.distance) return -1;
        return 1;

      });


      if (iterations-- < 0){
        break;
      }


    }

    if (foundPath) {


      return cache[cacheName] = this.simplify(foundPath);

    }

    return null;

  }


}
